import { render, staticRenderFns } from "./ClipItem.vue?vue&type=template&id=8020a820&scoped=true"
import script from "./ClipItem.vue?vue&type=script&lang=js"
export * from "./ClipItem.vue?vue&type=script&lang=js"
import style0 from "./ClipItem.vue?vue&type=style&index=0&id=8020a820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8020a820",
  null
  
)

export default component.exports